import React, { FC, useState } from 'react';
import { Accordion } from '@components/UIKit/Accordion/Accordion';
import { useTranslation } from '@hooks/useTranslation';
import { Toy } from '@specs/views';
import parse from 'html-react-parser';
import { Header } from '@components/Pages/ToyPage/AccordionItems/Header';
import { Body } from '@components/Pages/ToyPage/AccordionItems/Body';
interface Props {
  description: NonNullable<Toy.Single['description']>;
}
export const AboutToy: FC<Props> = ({
  description
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return <Accordion toggler={<Header onClick={() => {
    setIsOpen(prev => !prev);
  }} isOpen={isOpen}>
                    {tr({
      id: 'toy.page.about.toy.title'
    })}
                </Header>} isOpen={isOpen} data-sentry-element="Accordion" data-sentry-component="AboutToy" data-sentry-source-file="AboutToy.tsx">
            <Body data-sentry-element="Body" data-sentry-source-file="AboutToy.tsx">
                {parse(description)}
            </Body>
        </Accordion>;
};